export const MessageEventType = {
    START: 'start',
    STOP: 'stop',
};
export const MessageDeliveryStatus = {
    ATTEMPTED: 'attempted',
    BLOCKED: 'blocked',
    OPTED_OUT: 'optedout',
    STARTED: 'started',
    STOPPED: 'stopped',
    UNREGISTERED: 'unregistered',
};
export var ProductIds;
(function (ProductIds) {
    ProductIds["CONFLUENCE"] = "confluence";
    ProductIds["ENGAGEKIT"] = "Engagekit";
    ProductIds["INTERCOM"] = "intercom";
    ProductIds["JIRA"] = "jira";
    ProductIds["PENDO"] = "pendo";
})(ProductIds || (ProductIds = {}));
//# sourceMappingURL=constants.js.map